//enum for WorkItemType Ids
export enum WorkItemTypes {
    Task = "1D9507EC-C9E9-4E7A-8ACB-22515E410828",
    AuditPlan = "DF2B4B70-2E63-4EC7-B49A-71F518AE84D8",
    Audit = "BDF35FBB-144E-462B-A5C3-9F68BF407D9D"
}